module.exports = __webpack_public_path__ + "assets/img/date.9d2ad57d.svg";